import Vue from 'vue'
import VueRouter from 'vue-router'

import MasterdataReasons from '@/views/Masterdata/Reasons'
import MasterdataForecasts from '@/views/Masterdata/Forecasts'
import MasterdataBusMatrix from '@/views/Masterdata/BusMatrix'

Vue.use(VueRouter)

// const APP_TITLE = 'Arriva'

const routes = [
  {
    path: '/:district_id/masterdata',
    name: 'Masterdata',
    meta: {
      title: 'Stamdata'
    },

    children: [
      {
        path: 'reasons',
        meta: {
          title: 'Orsaker'
        },
        component: MasterdataReasons
      },
      {
        path: 'forecasts',
        meta: {
          title: 'Prognoser'
        },
        component: MasterdataForecasts
      },
      {
        path: 'bus-matrix',
        meta: {
          title: 'Busstids matris'
        },
        component: MasterdataBusMatrix
      }
    ],

    component: () =>
      import(
        /* webpackChunkName: "masterdata" */ '../views/Masterdata/index.vue'
      )
  },
  {
    path: '/:district_id/history',
    name: 'History',
    meta: {
      title: 'Historik'
    },

    component: () =>
      import(/* webpackChunkName: "history" */ '../views/History/index.vue')
  },
  {
    path: '/:district_id/history/:event_uuid',
    name: 'HistoryEvent',
    meta: {
      title: 'Historik - händelse'
    },

    component: () =>
      import(
        /* webpackChunkName: "history-event" */ '../views/History/Event/index.vue'
      )
  },
  {
    path: '/:district_id/link-deviation/delay',

    name: 'LinkDeviationDelay',
    meta: {
      title: 'Externa avvikelser - Förseningar'
    },

    component: () =>
      import(
        /* webpackChunkName: "linkDeviationDelay" */ '../views/LinkDeviation/Delay/index.vue'
      )
  },
  {
    path: '/:district_id/link-deviation/train-deviation',

    name: 'LinkDeviationTrainDeviation',
    meta: {
      title: 'Externa avvikelser - tågavvikelser'
    },

    component: () =>
      import(
        /* webpackChunkName: "linkDeviationDelay" */ '../views/LinkDeviation/TrainDeviation/index.vue'
      )
  },
  {
    path: '/:district_id/link-deviation/crew-deviation',

    name: 'LinkDeviationCrewDeviation',
    meta: {
      title: 'Externa avvikelser - bemanningsavvikelser'
    },

    component: () =>
      import(
        /* webpackChunkName: "linkDeviationCrewDeviations" */ '../views/LinkDeviation/Crew/index.vue'
      )
  },
  {
    path: '/:district_id/event/:event_uuid?',
    name: 'Dsp',
    meta: {
      title: 'DSP'
    },

    component: () => import(/* webpackChunkName: "dsp" */ '../views/Dsp.vue')
  },

  {
    path: '/:district_id/event',
    name: 'Dsp2',
    meta: {
      title: 'DSP'
    },

    component: () => import(/* webpackChunkName: "dsp2" */ '../views/Dsp.vue')
  },
  {
    path: '/:district_id/duwa',
    name: 'Duwa',
    meta: {
      title: 'Duwa'
    },

    component: () =>
      import(/* webpackChunkName: "duwa" */ '../views/Duwa/index.vue')
  },
  {
    path: '/:district_id/sms-log',
    name: 'SMS Log',
    meta: {
      title: 'SMS Logg'
    },

    component: () =>
      import(/* webpackChunkName: "sms-logg" */ '../views/SmsLog/index.vue')
  },
  {
    path: '/:district_id/odoc',
    name: 'Odoc',
    meta: {
      title: 'Ödoc'
    },

    component: () =>
      import(/* webpackChunkName: "odoc" */ '../views/Odoc/index.vue')
  },
  {
    path: '/:district_id/tib-banner',
    name: 'TIB Banner',
    meta: {
      title: 'TIB Banner'
    },

    component: () =>
      import(
        /* webpackChunkName: "tib-banner" */ '../views/TibBanner/index.vue'
      )
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
